import React, { Component } from 'react'
import { connect } from 'react-redux'
import Plx from 'react-plx';

//import T from '../../../translate/T'
import Footer from './../../../../src/SPRINTA/Footer';
import { Container, ContainerFluid, Row, Col } from './../../../../src/SPRINTA/atoms/Grid';
import Button from './../../../../src/SPRINTA/atoms/Button';
import CoverImage from './../../../../src/SPRINTA/atoms/CoverImage';
import './../effects.css';
import SlickSlider from './../../third-party/SlickCarousel';
import ContactForm from '../../Components/ContactForm'


import style from './style.css'

const headerparallax = [
  {
    start: 0,
    duration: 800,
    properties: [
      {
        startValue: 0,
        endValue: 50,
        property: "translateY"
      }
    ]
  }
]

class ExpSubhome extends Component {
  constructor() {
    super();
    this.state = {
       atletaprincipal: 'hidden',
       ball1: 'hidden',
       ball2: 'hidden',
       ball3: 'hidden',
       text1: 'hidden',
       text2: 'hidden',
       text3: 'hidden',
       line1: 'hidden',
       line2: 'hidden'
    }
  }
  handleScroll() {
    //console.log(document.documentElement.scrollTop);
    var atletaprincipal = 'animated fadeInRight';
    var ball1 = 'ball1 animated zoomIn';
    var ball2 = 'ball2 animated zoomIn';
    var ball3 = 'ball3 animated zoomIn';
    var text1 = 'text1 animated fadeIn';
    var text2 = 'text2 animated fadeIn';
    var text3 = 'text3 animated fadeIn';

    if (document.documentElement.scrollTop > 200 && this.state.atletaprincipal !== atletaprincipal){
      this.setState({
        atletaprincipal: atletaprincipal
      })
    }
    if (document.documentElement.scrollTop > 800 && this.state.ball1 !== ball1){
      this.setState({
        ball1: ball1
      })
      setTimeout(function(){
        this.setState({
          text1: text1
        })
      }.bind(this), 500);
      setTimeout(function(){
        this.setState({
          line1: 'line1 animated fadeIn'
        })
      }.bind(this), 1000);
      setTimeout(function(){
        this.setState({
          ball2: ball2
        })
      }.bind(this), 1500);
      setTimeout(function(){
        this.setState({
          text2: text2
        })
      }.bind(this), 2000);
      setTimeout(function(){
        this.setState({
          line2: 'line2 animated fadeIn'
        })
      }.bind(this), 2500);
      setTimeout(function(){
        this.setState({
          ball3: ball3
        })
      }.bind(this), 3000);
      setTimeout(function(){
        this.setState({
          text3: text3
        })
      }.bind(this), 3500);
    }
   }
   componentDidMount() {
     window.onscroll = () => this.handleScroll()
   }
  render() {
    return (
      <div>
        <ContainerFluid>
          <Row>
            <Col size="12" style={{paddingLeft: '0',paddingRight: '0'}}>
            <Plx
            className={style.instheader}
              parallaxData={ headerparallax }
            >
            <CoverImage className={style.instheader} image={require('./background.jpg')}>
            <Container>
              <h1>Experiências únicas</h1>
              <p>Viva experiências memoráveis<br />com outros atletas</p>
            </Container>
          </CoverImage>
            </Plx>
            </Col>
            <Col size="12" style={{padding:'30px 0 0 0', overflow:'hidden'}}>
                <Container>
                  <Row>
                    <Col size="12 6" className={style.instpublico}>
                      <h1>Já pensou treinar<br />com <b>seu ídolo</b>?</h1>
                      <p>Viva experiências únicas com atletas experientes através de treinos, competições ou atividades de lazer exclusivas.<br />
                      Melhore seu tempo, aumente sua performance, supere seus limites e faça novos companheiros de treino. Quem sabe um dia você treina com seu ídolo?
                      </p>
                      <a href='/explore'>
                        <Button inline theme="light">Procure experiências</Button>
                      </a>
                    </Col>
                    <Col size='12' style={{ height: '300px' }} hiddenMD hiddenLG />
                    <Col size="12 6" style={{position: 'absolute', bottom: 0, right: 0}}>
                      <div className={this.state.atletaprincipal} style={{position:'relative', top:'3px'}}>
                        <img alt="" src={require('./atleta.png')}/>
                      </div>
                    </Col>
                  </Row>
                </Container>
            </Col>
            <Col size="12" className={style.instmedida}>
              <Container>
                <Row>
                  <Col size="12 6"></Col>
                  <Col size="12 6">
                    <h1>Nem muito fácil,<br />nem muito difícil.<br /><b>Na medida certa</b>.</h1>
                    <p>Nada de ficar para trás no treino. Escolha a complexibilidade da experiência e vá treinando para subir de nível! Experiências maiores e desafiadoras ajudarão você a transpor seus limites e ainda fornecer memórias incríveis. Desafie-se.</p>
                    <Row>
                       <Col hiddenSM>
                          <div className={style.instgraph}>
                            <div className={this.state.ball1}></div>
                            <div className={this.state.line1}></div>
                            <div className={this.state.ball2}></div>
                            <div className={this.state.line2}></div>
                            <div className={this.state.ball3}></div>
                          </div>
                        </Col>
                     </Row>

                    <Row className={style.instmedidatext}>
                       <Col size='9 12' float='center right'>
                          <Row>
                            <Col size="12 4" className={this.state.text1}>
                              <div className={style.instmedtexbox}>
                                <p>Experiência</p>
                              </div>
                              <p>Experiências leves, com pouco esforço físico. Ideal para iniciar a prática esportiva ou mesmo lazer.</p>
                            </Col>
                            <Col size="12 4" className={this.state.text2}>
                              <div className={style.instmedtexbox}>
                                <p>Experiência</p>
                              </div>
                              <p>Experiências intermediárias, com relativo esforço físico. Ideal para aqueles que já praticam o esporte e possuem algum preparo físico.</p>
                            </Col>
                            <Col size="12 4" className={this.state.text3}>
                              <div className={style.instmedtexbox}>
                                <p>Experiência</p>
                              </div>
                              <p>Experiências avançadas, com total dedicação de tempo e esforço. A experiência suprema para praticantes regulares de esporte.</p>
                            </Col>
                         </Row>

                      </Col>

                    </Row>
                  </Col>
                </Row>
              </Container>
            </Col>
            <Col size="12" className={style.instexp}>
              <Container>
                <h1>Crie sua <b>experiência</b></h1>
                <SlickSlider dots={true} color="white">
                  <div>
                    <img src={require('./cards/bikefit.png')} alt=""/>
                  </div>
                  <div>
                    <img src={require('./cards/canelagramadosonho.png')} alt=""/>
                  </div>
                  <div>
                    <img src={require('./cards/capeepic.png')} alt=""/>
                  </div>
                  <div>
                    <img src={require('./cards/circuitomorroreuter.png')} alt=""/>
                  </div>
                  <div>
                    <img src={require('./cards/cursomecanicamtb.png')} alt=""/>
                  </div>
                  <div>
                    <img src={require('./cards/dolomita.png')} alt=""/>
                  </div>
                  <div>
                    <img src={require('./cards/lagoabarros.png')} alt=""/>
                  </div>
                  <div>
                    <img src={require('./cards/meuprimeiroIronman.png')} alt=""/>
                  </div>
                  <div>
                    <img src={require('./cards/minhaprimeiramaratona.png')} alt=""/>
                  </div>
                  <div>
                    <img src={require('./cards/pedal3barragens.png')} alt=""/>
                  </div>
                  <div>
                    <img src={require('./cards/pedalbalsa.png')} alt=""/>
                  </div>
                </SlickSlider>
              </Container>
            </Col>
          </Row>
        </ContainerFluid>
        <Col size="12" text='center' style={{paddingTop: '30px', paddingBottom: '30px'}}>
          <Container>
           <ContactForm />
          </Container>
        </Col>
        <Footer lang="pt-BR" />
      </div>
    )
  }
}

const mapStateToProps = store => ({})
const mapDispatchToProps = {

}
export default connect( mapStateToProps, mapDispatchToProps )(ExpSubhome)



// WEBPACK FOOTER //
// ./src/App/pages/Experiencias/index.js